import React, {useEffect, useState} from "react";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import UploadWidget from "../UploadWidget";
import FooterMovil from "../FooterMovil";
import "../../style/Sell.css";
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from "../../utils/apiClient";
import { notification } from 'antd';

function Sell() {
  const { authToken } = useAuth();
  const navigate = useNavigate();

  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [images, setImages] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);

  const [selectedBrand, setSelectedBrand] = useState('');
  const [selectedModel, setSelectedModel] = useState('');
  const [selectedUBI, setSelectedUBI] = useState('');
  const [selectedgastype, setSelectedgastype] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [selectedCondition, setSelectedCondition] = useState('');
  const [selectedTrans, setSelectedTrans] = useState('');
  const [selectedTrac, setSelectedTrac] = useState('');
  const [mainImage, setMainImage] = useState(null);
  const [, setShowDeleteModal] = useState(false);
  const [, setImageToDelete] = useState(null);


  const handleSelectMainImage = (url) => {
    setMainImage(url);
  };

  const handleDeleteImage = (url) => {
    setImageToDelete(url);
    setShowDeleteModal(true);
  };

  const [checkboxes, setCheckboxes] = useState({
    grua: false,
    costosintro: false,
    enciende: false,
    camina: false,
    costosvias: false,
    costosins: false,
    placas: false,
    inscripcion: false,
  });
  const [formData, setFormData] = useState({
    lote: '',
    marca: '',
    millaje: '',
    condicion: '',
    transmision: '',
    modelo: '',
    precio: '',
    motor: '',
    traccion: '',
    anio: '',
    ubicacion: '',
    combustible: '',
    tipo: '',
    comentario: '',
    link360: '',
    listado: '',
    precioOferta: '',
    contacto: ''
  });

  const handleUploadSuccess = (url) => {
    setImages((prev) => [...prev, url]);
  };

  const gastypes = ['Gasolina', 'Disel', 'N/A'];
  const typecars = [
    'Camioncito',
    'Pick Up',
    'Sedan',
    'Camioneta',
    'Cabezal',
    'Bus',
    'Camion',
    'Motocicleta',
    'Varios',
  ];
  const transmisiones = ['Automatica', 'Mecánica', 'N/A'];
  const tracciones = ['Delantera', 'Trasera', '4x4', 'N/A'];
  const condiciones = ['Chocado', 'Arreglado', 'Buen Estado'];
  const Ubications = ['USA', 'Puerto Cortez', 'Tegucigalpa', 'Transito', 'San Lorenzo'];

  const getMarcas = async () => {
    try {
      const res = await api.get('marcasymodelos/marca');
      setMarcas(res.data);
    } catch (error) {
      console.error('Error fetching marcas:', error);
    }
  };

  const getModelos = async (marcaID) => {
    try {
      const data = { marca: marcaID };
      const res = await api.post('marcasymodelos/modelobymarca', data);
      setModelos(res.data);
    } catch (error) {
      console.error('Error fetching modelos:', error);
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get('usuario/getbyToken');
        if (!res.data.verficado) {
          setShowVerificationModal(true);
        }
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    };

    if (!authToken) {
      navigate('/login');
    } else {
      fetchUser();
      getMarcas();
    }
  }, [authToken, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBrandChange = (e) => {
    setSelectedBrand(e.target.value);
    setFormData((prev) => ({ ...prev, marca: e.target.value }));
    const result = marcas.find((m) => m.Nombre === e.target.value);
    if (result) {
      getModelos(result._id);
    } else {
      setModelos([]);
    }
  };

  const handleModelChange = (e) => {
    setSelectedModel(e.target.value);
    setFormData((prev) => ({ ...prev, modelo: e.target.value }));
  };

  const handleTransChange = (e) => {
    setSelectedTrans(e.target.value);
    setFormData((prev) => ({ ...prev, transmision: e.target.value }));
  };

  const handleTracChange = (e) => {
    setSelectedTrac(e.target.value);
    setFormData((prev) => ({ ...prev, traccion: e.target.value }));
  };

  const handleConditionChange = (e) => {
    setSelectedCondition(e.target.value);
    setFormData((prev) => ({ ...prev, condicion: e.target.value }));
  };

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
    setFormData((prev) => ({ ...prev, tipo: e.target.value }));
  };

  const handleUBIChange = (e) => {
    setSelectedUBI(e.target.value);
    setFormData((prev) => ({ ...prev, ubicacion: e.target.value }));
  };

  const handleGasChange = (e) => {
    setSelectedgastype(e.target.value);
    setFormData((prev) => ({ ...prev, combustible: e.target.value }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxes((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!authToken) {
      navigate('/login');
      return;
    }
    try {
      const data = {
        ...formData,
        marca: selectedBrand || formData.marca,
        modelo: selectedModel || formData.modelo,
        condicion: selectedCondition,
        transmission: selectedTrans,
        traccion: selectedTrac,
        ubicacion: selectedUBI,
        combustible: selectedgastype,
        tipo: selectedType,
        imagenes: images,
        camina: checkboxes.camina,
        Introduccion: checkboxes.costosintro,
        enciende: checkboxes.enciende,
        viasPublicas: checkboxes.costosvias,
        gruaIncluida: checkboxes.grua,
        costosPlacas: checkboxes.placas,
        gastosDeInscripcion: checkboxes.costosins,
      };
      await api.post('pendingCarAds/', data);
      notification.success({
        message: 'Operación Exitosa',
        description: 'Anuncio enviado correctamente.',
      });
      setFormData({
        lote: '',
        marca: '',
        millaje: '',
        condicion: '',
        transmision: '',
        modelo: '',
        precio: '',
        motor: '',
        traccion: '',
        anio: '',
        ubicacion: '',
        combustible: '',
        tipo: '',
        comentario: '',
        link360: '',
        listado: '',
        precioOferta: '',
      });
      setSelectedBrand('');
      setSelectedModel('');
      setSelectedUBI('');
      setSelectedgastype('');
      setSelectedType('');
      setSelectedCondition('');
      setSelectedTrans('');
      setSelectedTrac('');
      setCheckboxes({
        grua: false,
        costosintro: false,
        costosins: false,
        costosvias: false,
        destacado: false,
        enciende: false,
        placas: false,
        camina: false,
      });
      setImages([]);
    } catch (error) {
      console.error('Error posting data:', error);
      notification.error({
        message: 'Error',
        description: 'No se pudo enviar la información.',
      });
    }
  };

  return (
    <>
      <Navbar />
      <div className="honduautos-backk">
        <center>
          <p className="sell-title">Vende tu Carro</p>
        </center>
        <div className="form-container-sell">
          <div className="lote">
            <input
              type="text"
              className="sell-input"
              placeholder="Lote"
              name="lote"
              value={formData.lote}
              onChange={handleChange}
            />
          </div>
          <div className="widget">
            <UploadWidget onUploadSuccess={handleUploadSuccess} />
          </div>
          <div className="images-container-cloudinary">
                  {images.length > 0 ? (
                    <>
                      <div className="main-image-container">
                        <img
                          src={mainImage || images[0]}
                          alt="Main Uploaded"
                          className="main-uploaded-image"
                        />
                      </div>
                      <div className="thumbnail-container">
                        {images.map((url, index) => (
                          <div
                            key={index}
                            className="thumbnail-image-container"
                          >
                            <img
                              src={url}
                              alt={`Uploaded ${index}`}
                              className="thumbnail-uploaded-image"
                              onClick={() => handleSelectMainImage(url)}
                              style={{
                                cursor: "pointer",
                                border:
                                  mainImage === url ? "2px solid blue" : "none",
                              }}
                            />
                            <button
                              onClick={() => handleDeleteImage(url)}
                              type="button"
                              className="delete-button"
                            >
                              ‎
                            </button>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <p>No images uploaded</p>
                  )}
                </div>
          <div className="grid-sell">
            <div className="columns">
              <select
                name="marca"
                value={selectedBrand}
                onChange={handleBrandChange}
                id="marca"
              >
                <option value="">Marca</option>
                {marcas.map((marca) => (
                  <option key={marca._id} value={marca.Nombre}>
                    {marca.Nombre}
                  </option>
                ))}
              </select>
              <input
                type="text"
                placeholder="Millaje"
                name="millaje"
                value={formData.millaje}
                onChange={handleChange}
              />
              <select
                name="condicion"
                value={selectedCondition}
                onChange={handleConditionChange}
                id="condicion"
              >
                <option value="">Condicion</option>
                {condiciones.map((cond) => (
                  <option key={cond} value={cond}>
                    {cond}
                  </option>
                ))}
              </select>
              <select
                name="transmision"
                value={selectedTrans}
                onChange={handleTransChange}
                id="transmision"
              >
                <option value="">Transmisión</option>
                {transmisiones.map((trans) => (
                  <option key={trans} value={trans}>
                    {trans}
                  </option>
                ))}
              </select>
            </div>
            <div className="columns">
              <select
                name="modelo"
                value={selectedModel}
                onChange={handleModelChange}
                id="modelo"
              >
                <option value="">Modelo</option>
                {modelos.map((modelo) => (
                  <option key={modelo._id} value={modelo.Nombre}>
                    {modelo.Nombre}
                  </option>
                ))}
              </select>
              <input
                type="text"
                placeholder="Precio"
                name="precio"
                value={formData.precio}
                onChange={handleChange}
              />
              <input
                type="text"
                placeholder="Motor"
                name="motor"
                value={formData.motor}
                onChange={handleChange}
              />
              <select
                name="traccion"
                value={selectedTrac}
                onChange={handleTracChange}
                id="traccion"
              >
                <option value="">Tracción</option>
                {tracciones.map((trac) => (
                  <option key={trac} value={trac}>
                    {trac}
                  </option>
                ))}
              </select>
            </div>
            <div className="columns">
              <input
                type="text"
                placeholder="Año"
                name="anio"
                value={formData.anio}
                onChange={handleChange}
              />
              <select
                name="ubicacion"
                value={selectedUBI}
                onChange={handleUBIChange}
                id="ubicacion"
              >
                <option value="">ubicacion</option>
                {Ubications.map((ubi) => (
                  <option key={ubi} value={ubi}>
                    {ubi}
                  </option>
                ))}
              </select>
              <select
                name="combustible"
                value={selectedgastype}
                onChange={handleGasChange}
                id="combustible"
              >
                <option value="">Combustible</option>
                {gastypes.map((gas) => (
                  <option key={gas} value={gas}>
                    {gas}
                  </option>
                ))}
              </select>
              <select
                name="tipo"
                value={selectedType}
                onChange={handleTypeChange}
                id="tipo"
              >
                <option value="">Tipo</option>
                {typecars.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="grid-sell-movil">
              <select name="marca" value={selectedBrand} onChange={handleBrandChange} id="marca-m">
                  <option value="">Marca</option>
                  {marcas.map((marca) => (
                    <option key={marca._id} value={marca.Nombre}>
                      {marca.Nombre}
                    </option>
                  ))}
              </select>
              <input type="text" placeholder="Millaje" name="millaje" value={formData.millaje} onChange={handleChange} />
              <select name="condicion" value={selectedCondition} onChange={handleConditionChange} id="condicion-m">
                  <option value="">Condicion</option>
                  {condiciones.map((cond) => (
                    <option key={cond} value={cond}>
                      {cond}
                    </option>
                  ))}
              </select>
              <select name="transmision" value={selectedTrans} onChange={handleTransChange} id="transmision-m">
                  <option value="">Transmisión</option>
                  {transmisiones.map((trans) => (
                    <option key={trans} value={trans}>
                      {trans}
                    </option>
                  ))}
              </select>
              <select name="modelo" value={selectedModel} onChange={handleModelChange} id="modelo-m">
                  <option value="">Modelo</option>
                  {modelos.map((modelo) => (
                    <option key={modelo._id} value={modelo.Nombre}>
                      {modelo.Nombre}
                    </option>
                  ))}
              </select>
              <input type="text" placeholder="Precio" name="precio" value={formData.precio} onChange={handleChange} />
              <input type="text" placeholder="Motor" name="motor" value={formData.motor} onChange={handleChange} />
              <select name="traccion" value={selectedTrac} onChange={handleTracChange} id="traccion-m">
                  <option value="">Tracción</option>
                  {tracciones.map((trac) => (
                    <option key={trac} value={trac}>
                      {trac}
                    </option>
                  ))}
              </select>
              <input type="text" placeholder="Año" name="anio" value={formData.anio} onChange={handleChange} />
              <select name="ubicacion" value={selectedUBI} onChange={handleUBIChange} id="ubicacion-m">
                  <option value="">ubicacion</option>
                  {Ubications.map((ubi) => (
                    <option key={ubi} value={ubi}>
                      {ubi}
                    </option>
                  ))}
              </select>
              <select name="combustible" value={selectedgastype} onChange={handleGasChange} id="combustible-m">
                  <option value="">Combustible</option>
                  {gastypes.map((gas) => (
                    <option key={gas} value={gas}>
                      {gas}
                    </option>
                  ))}
              </select>
              <select name="tipo" value={selectedType} onChange={handleTypeChange} id="tipo-m">
                  <option value="">Tipo</option>
                  {typecars.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
              </select>
          </div>
          <div className="grid-sell-last">
            <div className="columns-2">
              <input
                type="text"
                placeholder="Comentario"
                name="comentario"
                value={formData.comentario}
                onChange={handleChange}
              />
              <input
                type="text"
                placeholder="Agregue enlace 360"
                name="link360"
                value={formData.link360}
                onChange={handleChange}
              />
            </div>
            <div className="columns-2">
              <input
                type="text"
                placeholder="Listado"
                name="listado"
                value={formData.listado}
                onChange={handleChange}
              />
              <input
                type="text"
                placeholder="Precio Oferta"
                name="precioOferta"
                value={formData.precioOferta}
                onChange={handleChange}
              />
              <input
                type="text"
                placeholder="Numero de contacto (+504 1111-1111)"
                name="contacto"
                value={formData.contacto}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="grid-sell-checks">
                <div className="columnsdown">
                  <div className="element-checks">
                    <input
                      type="checkbox"
                      className="check"
                      name="grua"
                      checked={checkboxes.grua}
                      onChange={handleCheckboxChange}
                    />
                    Grua incluida
                  </div>
                  <div className="element-checks">
                    <input
                      type="checkbox"
                      className="check"
                      name="costosintro"
                      checked={checkboxes.costosintro}
                      onChange={handleCheckboxChange}
                    />
                    Costos de Introduccion
                  </div>
                  <div className="element-checks">
                    <input
                      type="checkbox"
                      className="check"
                      name="costosins"
                      checked={checkboxes.costosins}
                      onChange={handleCheckboxChange}
                    />
                    Costos de Inscripcion
                  </div>
                </div>
                <div className="columnsdown">
                  <div className="element-checks">
                    <input
                      type="checkbox"
                      className="check"
                      name="costosvias"
                      checked={checkboxes.costosvias}
                      onChange={handleCheckboxChange}
                    />
                    Costos de Vias Publicas
                  </div>
                  <div className="element-checks">
                    <input
                      type="checkbox"
                      className="check"
                      name="enciende"
                      checked={checkboxes.enciende}
                      onChange={handleCheckboxChange}
                    />
                    Enciende
                  </div>
                  <div className="element-checks">
                    <input
                      type="checkbox"
                      className="check"
                      name="placas"
                      checked={checkboxes.placas}
                      onChange={handleCheckboxChange}
                    />
                    Costos de Placas
                  </div>
                </div>
                <div className="columnsdown">
                  <div className="element-checks">
                    <input
                      type="checkbox"
                      className="check"
                      name="camina"
                      checked={checkboxes.camina}
                      onChange={handleCheckboxChange}
                    />
                    Camina
                  </div>
                </div>
              </div>

          <center>
            <button type="button" className="add-car" onClick={handleSubmit}>
              AGREGAR AUTO
            </button>
          </center>

        </div>
      </div>
      <div className="footer">
      <Foooter />
      </div>
      <div className="footer-movil">
      <FooterMovil/>
      </div>
      {showVerificationModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p>Verificación de usuario es requerida</p>
            <button className="red-button" onClick={() => navigate('/verificar')}>
              Verificar ahora
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Sell;
